const HUBSPOT_SCRIPT_URL = 'https://js-ap1.hsforms.net/forms/embed/v2.js'
const HUBSPOT_PORTAL_ID = '20189259'
const HUBSPOT_REGION = 'ap1'

export enum HubSpotFormId {
  SubmitScoreboard = 'submitScoreboard',
  GetInTouch = 'getInTouch',
}

type HubSpotCreateOptions = {
  formId: string
  portalId: string
  region: string
}

type HubSpotForm = {
  createOptions: HubSpotCreateOptions
  id: HubSpotFormId
  scriptUrl: string
}

export const HUBSPOT_FORMS: Record<HubSpotFormId, HubSpotForm> = {
  [HubSpotFormId.SubmitScoreboard]: {
    id: HubSpotFormId.SubmitScoreboard,
    scriptUrl: HUBSPOT_SCRIPT_URL,
    createOptions: {
      formId: '77240d4f-acc7-4995-932e-e9bc6ac62be3',
      portalId: HUBSPOT_PORTAL_ID,
      region: HUBSPOT_REGION,
    },
  },
  [HubSpotFormId.GetInTouch]: {
    id: HubSpotFormId.GetInTouch,
    scriptUrl: HUBSPOT_SCRIPT_URL,
    createOptions: {
      formId: '45d53edf-dacf-4c97-b1b5-084b084278b0',
      portalId: HUBSPOT_PORTAL_ID,
      region: HUBSPOT_REGION,
    },
  },
}
